import { PieChart, PieSeries } from "@amcharts/amcharts4/charts";
import { create } from "@amcharts/amcharts4/core";
import _ from "lodash";
import React, { Component } from "react";
import WebFont from "webfontloader";
import "../../../assets/styles/component/legend.scss";
import { disposeChart } from "../helpers/chartHelpers";
import { legendConfiguration } from "../helpers/configurations";
import { ThemeInt } from "../helpers/types";

interface Props {
  data: Array<Record<string, number | string>>;
  theme: ThemeInt;
  chartId: string;
  valueField: string;
  categoryField: string;
}

class ProductPerformancePieChart extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  chart!: PieChart;
  chartId = this.props.chartId;

  componentDidMount() {
    WebFont.load({
      custom: {
        families: ["nissan"],
        urls: ["../../../assets/fonts/fonts.css"],
      },
      // @ts-ignore
      active: this.initChart(),
      timeout: 8000,
    });
  }

  componentDidUpdate(prevProps: any) {
    //Handle refreshing the chart when the dataset changes
    if (!_.isEqual(prevProps, this.props)) {
      disposeChart(this.chartId).then((res) => {
        this.initChart();
      });
    }
  }

  componentWillUnmount() {
    disposeChart(this.chartId);
  }

  initChart() {
    const { data, theme, valueField, categoryField } = this.props;
    this.chart = create(this.chartId, PieChart);
    this.chart.data = data;
    this.chart.numberFormatter.numberFormat = "#.";

    this.chart.layout = "vertical";

    // Legend configuration
    this.chart.legend = legendConfiguration(theme);
    this.chart.legend.fontSize = "1.2em";
    this.chart.legend.maxWidth = 5;
    this.chart.legend.valueLabels.template.disabled = true;
    this.chart.legend.position = "right";
    this.chart.legend.itemContainers.template.paddingBottom = 10;
    this.chart.legend.itemContainers.template.height;
    this.chart.legend.labels.template.fontSize = "0.85em";
    this.chart.legend.markers.template.height = 10;
    this.chart.legend.markers.template.width = 10;

    const series = this.chart.series.push(new PieSeries());
    series.dataFields.value = valueField;
    series.dataFields.category = categoryField;
    series.labels.template.text = "";
    series.ticks.template.disabled = true;
    // series.alignLabels = false;
    // series.labels.template.radius = percent(-25);
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.tooltipText = "{category}: {value}";
  }

  render() {
    return (
      <>
        <div className={"chartWrapper"}>
          <div id={this.props.chartId} data-test-id={this.props.chartId} className={"graph"} />
        </div>
      </>
    );
  }
}

export default ProductPerformancePieChart;
